import { SNACKS_CONTAINER_ID, SWEETS_CONTAINER_ID } from './utils';

export const getOccasionContainerSubtitle = (containerId: number) => {
  switch (containerId) {
    case SWEETS_CONTAINER_ID:
      return 'Sweets can be a single serving or multiple servings (like a tub of cookie dough or a multipack of bars).';
    case SNACKS_CONTAINER_ID:
      return 'Snacks can be a single serving or multiple servings (like a tub of cookie dough or a multipack of bars).';
    default:
      return undefined;
  }
};
